<template>
  <div class="course-card" @click="handleRoute('/view-course/'+id)">
    <img :src="image" alt="Course Image" class="course-image" />
    <div class="course-content">
      <h3>{{ title }}</h3>
      <!-- <p class="progress-text">{{ progress }}%</p> -->

      <!-- <div class="progress-bar">
        <div class="progress" :style="{ width: progress + '%' }"></div>
      </div> -->
    </div>
    <button class="view-btn">View Course</button>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    progress: {
      type: Number,
      required: true,
    },
  },
  methods: {
    handleRoute(route) {
      this.$router.push(route)
    },
  }
};
</script>

<style scoped>
/* General Styling */
.course-card {
  cursor: pointer;
  border: 1px solid #ccc;
  border-radius: 5px;
  overflow: hidden;
  color: #fff;
  background-color: #121E4A;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.2s ease;
  display: flex;
  max-width: 300px;
  flex-direction: column;
}
.course-card:hover {
  transform: scale(1.1);
  transition: all .5s;
  cursor: pointer;
}
.course-image {
  width: 100%;
  height: auto;
  border-bottom: 5px solid #f0c57a;
}
.course-content {
  padding: 0.2rem 1rem 1rem;
  flex: 1;
}
.course-content h3 {
  font-size: 1rem;
  margin: 0.5rem 0;
  text-align: left;
}
.progress-bar {
  background-color: #e5e5e5;
  border-radius: 5px;
  overflow: hidden;
  height: 10px;
  margin: 0.5rem 0;
  position: relative;
}
.progress {
  background-color: #4caf50;
  height: 100%;
  transition: width 0.3s ease;
}
.progress-text {
  text-align: right;
  font-size: 0.9rem;
  color: #555;
}
.view-btn {
  padding: 0.5rem 1rem;
  border: none;
  width: 100%;
  background-color: #f0c57a;
  color: #000;
  cursor: pointer;
  margin-top: 1rem;
}
.view-btn:hover {
  background-color: #aacae7;
}


@media screen and (max-width: 850px) {
  .course-card {
    max-width: initial;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .course-content h3 {
    font-size: 0.9rem;
  }
  .progress-bar {
    height: 8px;
  }
  .view-btn {
    font-size: 0.85rem;
    padding: 0.4rem 0.8rem;
  }
}

@media (max-width: 480px) {
  .course-content h3 {
    font-size: 0.8rem;
  }
  .view-btn {
    font-size: 0.75rem;
  }
}
</style>
